import { ConnectivityStatusEnum } from "@/model/data/status/ConnectivityStatusEnum";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class RefreshConnectivityStatusResData extends ApiGenericResponse {
    connectivityStatus: ConnectivityStatusEnum;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ConnectivityStatus != null && obj.ConnectivityStatus != undefined) this.connectivityStatus = obj.ConnectivityStatus;
    }
}
